export default __webpack_public_path__ + "static/media/main_intro.efcdd451.mp3";